import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { SimpleResponse } from 'Types/simpleResponse'
import { ArticleAttachmentModel } from 'Pages/knowledge'

export const fileApi = {
	createArticleAttachmentApi: async (
		article_id: number,
		file: File,
		file_original_name: string
	) => {
		const data = new FormData()
		data.append('[data][article_id]', `${article_id}`)
		data.append('[data][file]', file)
		data.append('[data][file_original_name]', file_original_name)
		const res = await axiosDS().post<ArticleAttachmentModel>(
			`${urls.knowledge.article}/${article_id}/attachment`,
			data
		)
		return res.data
	},
	deleteArticleAttachmentApi: async (article_id: number, attachment_id: number) => {
		const res = await axiosDS().delete<SimpleResponse>(
			`${urls.knowledge.article}/${article_id}/attachment/${attachment_id}`
		)
		return res.data
	},
	getArticleAttachmentApi: async (url: string) => {
		const res = await axiosDS().get<Blob>(url, {
			responseType: 'blob',
		})
		return res.data
	},
}
